import React, { Component } from 'react';

import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import OptionsDropdown from 'components/shared/OptionsDropdown';
import SurveyStatus from './SurveyStatus';

import { List, AutoSizer } from 'react-virtualized';

import { isFilterInStrings } from 'helpers/StringHelper.js';
import { toFriendlyDateString } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

class SurveysMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typeFilter: '',
    };
  }

  getTypeFilterType = e => {
    this.setState({ typeFilter: e.target.value });
  };

  rowRenderer = ({ key, index, style }, filteredData) => {
    return (
      <div id="mobile_card" key={key} style={style}>
        <div className="row" style={{ marginBottom: '10px' }}>
          <div
            className="tenant_mobile_header"
            style={{ float: 'left', fontSize: '15px !important' }}
          >
            {filteredData[index].title}
          </div>
          <div
            className="mobile_subheader"
            style={{
              float: 'right',
              marginTop: '6px',
              padding: 0,
              fontSize: '14px',
            }}
          >
            <SurveyStatus status={filteredData[index].status} />
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader" style={{ float: 'right' }}>
            {filteredData[index].responses_count} responses
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader" style={{ float: 'right' }}>
            {filteredData[index].start_date
              ? toFriendlyDateString(filteredData[index].start_date)
              : getTranslatedString('landlordPortal.surveys.no')}
            &nbsp;{getTranslatedString('landlordPortal.surveys.startDate')}
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader" style={{ float: 'right' }}>
            {getTranslatedString('landlordPortal.surveys.expires')}
            {filteredData[index].expiration_date
              ? toFriendlyDateString(filteredData[index].expiration_date)
              : getTranslatedString('landlordPortal.surveys.never')}
          </div>
        </div>
        <div className="row">
          <div className="mobile_subheader" style={{ float: 'right' }}>
            <OptionsDropdown allowedOpen={!this.props.optionsDropdown}>
              {filteredData[index].status !== 'editing' && (
                <span>
                  <MenuItem
                    primaryText={getTranslatedString('landlordPortal.surveys.details')}
                    style={{ fontSize: '14px' }}
                    onClick={() => this.props.toggleSurveyResultsDialog(filteredData[index])}
                  />
                </span>
              )}
              {filteredData[index].status === 'editing' && (
                <span>
                  <MenuItem
                    primaryText={getTranslatedString('landlordPortal.surveys.edit')}
                    style={{ fontSize: '14px' }}
                    onClick={() => this.props.toggleSurveyDetailsDialog(filteredData[index])}
                  />
                </span>
              )}
              <MenuItem
                primaryText={getTranslatedString('landlordPortal.surveys.delete')}
                style={{ fontSize: '14px' }}
                onClick={() => this.props.deleteSurvey(filteredData[index].id)}
              />
            </OptionsDropdown>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const data = this.props.surveys || [];

    let filteredData = [];
    if (data && data.length > 0) {
      filteredData = data.filter(item =>
        isFilterInStrings(
          [
            item.property,
            item.title,
            item.start_date,
            item.expiration_date,
            item.responses,
            item.status,
          ],
          this.state.typeFilter
        )
      );
    }

    const DEFAULT_ROW_HEIGHT = 150;

    return (
      <div style={{ height: 'calc(100% - 100px)' }}>
        <div className="stage-header clearfix">
          <FlatButton
            label={getTranslatedString('landlordPortal.surveys.addSurvey')}
            type="submit"
            primary={true}
            backgroundColor={AccentColor()}
            hoverColor="grey"
            onClick={this.props.toggleSurveyDialog}
            style={{
              color: 'white',
              float: 'right',
              height: '30px',
              fontSize: '13px',
              lineHeight: '30px',
              marginTop: '3px',
            }}
          />
          <span className="page-title">{getTranslatedString('landlordPortal.surveys.header')}</span>
        </div>

        <div className="row" style={{ marginTop: '-20px' }}>
          <TextField
            hintText={getTranslatedString('landlordPortal.surveys.filter')}
            style={{ fontSize: '13px' }}
            value={this.state.typeFilter}
            onChange={this.getTypeFilterType}
          />
        </div>
        <AutoSizer>
          {({ height, width }) => (
            <List
              rowCount={filteredData.length}
              rowHeight={DEFAULT_ROW_HEIGHT}
              rowRenderer={cellData => this.rowRenderer(cellData, filteredData)}
              width={width}
              height={height}
            />
          )}
        </AutoSizer>
      </div>
    );
  }
}

export default SurveysMobile;
